interface SectionHeadingProps {
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ title, desc, align = 'left' }: SectionHeadingProps) {
  const alignCls = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  return (
    <div className={`mb-6 flex flex-col ${alignCls}`}>
      <div className="flex items-center gap-2">
        <span className="h-5 w-1 rounded-full bg-primary-500" aria-hidden="true"></span>
        <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">{title}</h2>
      </div>
      {desc && <p className={`mt-2 text-sm text-foreground-600 ${align === 'center' ? 'mx-auto' : ''}`}>{desc}</p>}
    </div>
  );
}